import { Card } from '@/components/ui/Card';
import { SidebarHeaderRisk } from './components/common/SidebarHeaderRisk';
import { SidebarContainer } from './components/sections/Container/SidebarContainer';
import { PreviewPanel } from './components/sections/Preview/PreviewPanel';
import { TwoDDocPanel } from './components/sections/2DDoc/TwoDDocPanel';
import { useSidebarResize } from './hooks/useSidebarResize';
import type { SidebarProps } from '../../types/sidebar.types';
// import { MRZPanel } from './components/sections/MRZ/MRZPanel';
import { DetectionsPanel } from './components/sections/Detections/DetectionsPanel';
import GradientRisk from '../GradientRisk';
import { Button } from '@/components/ui/Button';
import { FaArrowLeft } from 'react-icons/fa';
import { Row } from '@/components/ui/layout/Row';
import { Column } from '@/components/ui/layout/Column';

const Sidebar = ({
  pageIndex,
  setPageIndex,
  resultData,
  toggle,
  handleToggleChange,
  setHoverDetection,
  hoverDetection,
  hideDetectionCanvas,
  setIsPointerInSidebar,
  selected2DDoc,
  selectedMrzId,
  isResultLoading,
}: SidebarProps) => {
  const { sidebarRef } = useSidebarResize();

  const hideDetectionsPanel = toggle !== 'preview' && toggle !== 'mrz';

  return (
    <SidebarContainer ref={sidebarRef} onPointerChange={setIsPointerInSidebar}>
      {!isResultLoading && <GradientRisk variant={resultData?.risque ?? 0} />}

      <SidebarHeaderRisk
        risk={resultData?.risque ?? 0}
        isLoading={isResultLoading ?? false}
      />

      <div className="mt-4 flex flex-col gap-4">
        <Card>
          <PreviewPanel resultData={resultData} isLoading={isResultLoading} />
        </Card>
        <Card>
          <Column>
            <DetectionsPanel
              detections={resultData?.detections ?? []}
              setPageIndex={setPageIndex}
              setHoverDetection={setHoverDetection}
              pageIndex={pageIndex}
              handleToggleChange={handleToggleChange}
              hoverDetection={hoverDetection}
              hideDetectionCanvas={hideDetectionCanvas}
              hidden={hideDetectionsPanel}
              selectedMrzId={selectedMrzId}
              isLoading={isResultLoading}
            />
            {hideDetectionsPanel && (
              <Row justify="start" width="full">
                <Button
                  className="w-min !py-1 !pl-0"
                  variant="text"
                  onClick={() => handleToggleChange('preview')}
                >
                  <FaArrowLeft />
                  Retour
                </Button>
              </Row>
            )}

            {/* {toggle === 'mrz' && selectedMrz && <MRZPanel mrz={selectedMrz} />} */}

            {toggle === '2ddoc' && <TwoDDocPanel ddoc={selected2DDoc} />}
          </Column>
        </Card>
      </div>
    </SidebarContainer>
  );
};

export default Sidebar;
